import actionTypes from './index';

export default newDesignModalOpen =>
  ({ type: actionTypes.CONTROL_NEW_DESIGN_MODAL, payload: { newDesignModalOpen } });
